import { set } from "date-fns";
import React, { useState } from "react";
const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const years = Array.from({ length: 50 }, (_, i) => new Date().getFullYear() - i);

export function AddEducation({ saveEducationData, fullEducationData, setEducationArray, onCancel }) {
  const [university, setUniversity] = useState("");
  const [degree, setDegree] = useState("");
  const [startMonth, setStartMonth] = useState("");
  const [startYear, setStartYear] = useState("");
  const [endMonth, setEndMonth] = useState("");
  const [endYear, setEndYear] = useState("");
  const [isCurrent, setIsCurrent] = useState(false);

  const sortEducationData = (educationText) => {
    const sortedEducation = educationText
      .split("\n\n")
      .filter((e) => e.trim() !== "")
      .sort((a, b) => {
        const aLines = a.split("\n");
        const bLines = b.split("\n");
  
        const aDate = aLines[2]?.split(" - ")[1];
        const bDate = bLines[2]?.split(" - ")[1];

        if (aDate === "Present" && bDate !== "Present") return -1;
        if (bDate === "Present" && aDate !== "Present") return 1;
  
        if (aDate && bDate) {
          const [aMonth, aYear] = aDate.split(" ");
          const [bMonth, bYear] = bDate.split(" ");
          const monthIndex = (m) => months.indexOf(m);
          const aVal = new Date(Number(aYear), monthIndex(aMonth));
          const bVal = new Date(Number(bYear), monthIndex(bMonth));
          return bVal - aVal;
        }
        return 0;
      });
  
    setEducationArray(sortedEducation);
  };

  const handleSave = () => {
    if (!university || !degree || !startMonth || !startYear || (!isCurrent && (!endMonth || !endYear))) {
      alert("Please fill all required fields.");
      return;
    }
    const duration = `${startMonth} ${startYear} - ${isCurrent ? "Present" : `${endMonth} ${endYear}`}`;
    const finalString = `${university}\n${degree}\n${duration}`;

    saveNewEducationData(finalString, fullEducationData);
    onCancel(); // Close the AddEducation form
  };

  const saveNewEducationData = async (newEntryString, fullEducationString) => {
    const finalEducationString = fullEducationString
      ? `${fullEducationString}\n\n${newEntryString}`
      : newEntryString; // if empty initially
    // setEducationArray((prev) => [...prev, newEntryString]);
    sortEducationData(finalEducationString); // Sort the education data after adding new entry
    await saveEducationData(finalEducationString);
  };
  

  return (
    <div className="flex flex-col gap-2">
      <input
        className="w-full border-b border-gray-300 hover:border-[#365561] focus:border-[#365561] focus:outline-none text-sm pb-0.1"
        placeholder="University Name"
        value={university}
        onChange={(e) => setUniversity(e.target.value)}
      />
      <input
        className="w-full border-b border-gray-300 hover:border-[#365561] focus:border-[#365561] focus:outline-none text-sm pb-0.1"
        placeholder="Degree Name"
        value={degree}
        onChange={(e) => setDegree(e.target.value)}
      />
      <div className="flex gap-2">
        <select
          className="border-b border-gray-300 hover:border-[#365561] focus:border-[#365561] focus:outline-none text-sm pb-0.1 bg-transparent"
          value={startMonth}
          onChange={(e) => setStartMonth(e.target.value)}
        >
          <option value="">Start Month</option>
          {months.map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>
        <select
          className="border-b border-gray-300 hover:border-[#365561] focus:border-[#365561] focus:outline-none text-sm pb-0.1 bg-transparent"
          value={startYear}
          onChange={(e) => setStartYear(e.target.value)}
        >
          <option value="">Start Year</option>
          {years.map((y) => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
        <span className="self-center">-</span>
        {!isCurrent ? (
          <>
            <select
              className="border-b border-gray-300 hover:border-[#365561] focus:border-[#365561] focus:outline-none text-sm pb-0.1 bg-transparent"
              value={endMonth}
              onChange={(e) => setEndMonth(e.target.value)}
            >
              <option value="">End Month</option>
              {months.map((m) => (
                <option key={m} value={m}>{m}</option>
              ))}
            </select>
            <select
              className="border-b border-gray-300 hover:border-[#365561] focus:border-[#365561] focus:outline-none text-sm pb-0.1 bg-transparent"
              value={endYear}
              onChange={(e) => setEndYear(e.target.value)}
            >
              <option value="">End Year</option>
              {years.map((y) => (
                <option key={y} value={y}>{y}</option>
              ))}
            </select>
          </>
        ): (
          <span className="self-center text-gray-400">Present</span>
        )}
      </div>
      <label className="text-sm text-gray-600">
        <input
          type="checkbox"
          checked={isCurrent}
          onChange={() => setIsCurrent(!isCurrent)}
          className="mr-2"
        />
        Ongoing Course
      </label>

      <div className="flex justify-end gap-4 mt-6">
        <button
          onClick={handleSave}
          className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700"
        >
          Save
        </button>
        <button
          onClick={onCancel}
          className="bg-gray-400 text-white px-4 py-2 rounded-md hover:bg-gray-500"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}